import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { Avatar } from '@/components/Avatar/Avatar';
import { ExternalLink } from '@/components/Icons/ExternalLink';
import { useController } from '@/hooks/useController';
import { themeSelector } from '@/state/config';
import { ResponseWrapper } from '../ResponseWrapper/ResponseWrapper';
import { WebviewContainer } from './WebviewContainer';
import { WebviewModal } from './WebviewModal/WebviewModal';
import styles from './WebviewResponse.module.scss';
export const WebviewResponse = ({ webview, avatar, onButtonClick }) => {
    const { label, name, height } = webview;
    const [showModal, setShowModal] = useState(false);
    const theme = useRecoilValue(themeSelector);
    const { notifyWebviewClosed, notifyWebviewOpened } = useController();
    const handleCloseModal = useCallback(() => {
        setShowModal(false);
        notifyWebviewClosed();
    }, [notifyWebviewClosed]);
    const handleOpenModal = useCallback(() => {
        onButtonClick({ type: 'webview_button', label, value: name });
        setShowModal(true);
        notifyWebviewOpened();
    }, [label, name, notifyWebviewOpened, onButtonClick]);
    if (height === 'tall' || height === 'full') {
        return (_jsxs(ResponseWrapper, { children: [_jsx(Avatar, { avatar: avatar }), _jsx("div", { className: cn(styles.webviewContainer, styles[theme]), children: _jsx("p", { children: name }) }), _jsx("div", { className: styles.webviewButtonContainer, children: _jsxs("button", { onClick: handleOpenModal, children: [label, _jsx("span", { className: styles.externalLinkIcon, children: _jsx(ExternalLink, {}) })] }) }), _jsx(WebviewModal, { webview: webview, showModal: showModal, handleCloseModal: handleCloseModal, avatar: avatar })] }));
    }
    return (_jsxs(ResponseWrapper, { children: [_jsx(Avatar, { avatar: avatar }), _jsx(WebviewContainer, { webview: webview })] }));
};
